"use client";
import Image from "next/image";
import { useTranslations } from "next-intl";

import { useGetTeamListQuery } from "@/store";

export const OurTeam = () => {
  const t = useTranslations();

  const { data } = useGetTeamListQuery();
  return (
    <section className="md:pb-32  w-full mt-6 px-2">
      <div className="flex flex-col mx-auto justify-center items-center gap-2 mb-12">
        <div className="sm:text-[22px] text-lg text-mainDarkPurple md:text-[32px] text-center font-bold leaeding-[38px]">
          {t("ourTeam_pt")}
        </div>
        <div className="text-base text-mainLightPurpleText text-sans md:text-xl text-center font-semibold">
          {t("ourTeam_pst")}
        </div>
      </div>
      <div className="w-full flex flex-col gap-4 px-2 mx-auto max-w-[1296px]">
        <div className="grid place-items-center justify-center  grid-cols-teamGrid gap-[10px] sm:gap-[20px] md:gap-[24px]">
          {!!data &&
            !!data.body &&
            data?.body?.map(({ id, full_name, job_title, image }) => (
              <div
                key={id}
                className="flex flex-col  min-h-[220px] justify-center items-center border-2 border-[#A271F2] sm:rounded-[30px] rounded-[24px] sm:p-4 p-2 relative"
              >
                <div className="relative w-full">
                  {image ? (
                    <Image
                      src={process.env.API_URL + "/storage/" + image}
                      alt={id}
                      width={0}
                      height={0}
                      className="sm:w-[240px] xs:w-[200px] w-[150px] relative bottom-0 z-10 mx-auto md:h-[250px] sm:h-[230px] h-[200px] rounded-[14px] object-cover"
                    />
                  ) : (
                    ""
                  )}

                </div>
                <div className="relative sm:-top-10 -top-8 bg-white w-full h-[50px] py-4 z-20 rounded-[15px]">
                  <div className="flex flex-col justify-center items-center gap-1 ">
                    <span className="text-mainDarkPurple sm:text-xl text-base font-bold">
                      {full_name}
                    </span>
                    <span className="text-mainLightPurpleText text-sm font-bold text-center">
                      {job_title}
                    </span>
                  </div>
                </div>
                
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};
